import { orangeScreenReport } from "./orange-screen-report";
import { allEventActionsReport } from "./all-event-actions-report";
import { totemActionsReport } from "./totem-actions-report";

export const operationReports = {
	tabs: {
		orangeScreenReport: "Reporte de Pantalla Naranja",
		allEventActionsReport: "Acciones del Evento",
		totemActionsReport: "Acciones en el Tótem",
	},
	orangeScreenReport,
	allEventActionsReport,
	totemActionsReport,
};
